export default "__VITE_ASSET__4d18619d__"